import React from "react"
import styled from "styled-components"
import {
    MELOGY_TRANSPARENT,
    MELOGY_ALMOST_OPAQUE,
} from "../../style/colors"
import SongList from "../SongList"
import Button from "../buttons/Button"

const SidebarContainer = styled.div`
    z-index: 1001;
    display: flex;
    width: 200px;
    position: fixed;
    left: ${({ open }) => (open ? "0px" : "-200px")};
    transition: left 0.3s ease-in-out;
    height: 100%;
    background-color: ${MELOGY_ALMOST_OPAQUE};
`

const SidebarContent = styled.div`
    height: 100%;
    width: 184px;
    overflow: auto;
    display: flex;
    flex-direction: column;
`

const SidebarEdge = styled.div`
    width: 16px;
    height: 100%;
    cursor: pointer;
`

const SidebarSpace = styled.div`
    height: 16px;
    min-height: 16px;
    width: 184px;
`

const SidebarOutsideLayer = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: ${MELOGY_TRANSPARENT};
    z-index: 1000;
    display: ${({ open }) => (open ? "block" : "none")};
`

const LeftSidebar = ({
    songs,
    selectedSong,
    setSelectedSong,
    toggleLeftSideBar,
    isOpen,
}) => {
    return (
        <>
            <SidebarOutsideLayer open={isOpen} onClick={toggleLeftSideBar} />
            <SidebarContainer open={isOpen}>
                <SidebarContent>
                    <SidebarSpace />
                    <SongList
                        songs={songs}
                        selectedSong={selectedSong}
                        setSelectedSong={setSelectedSong}
                    />
                    <SidebarSpace />
                </SidebarContent>
                <SidebarEdge>
                    <Button
                        height="100%"
                        width="16px"
                        justifyContent="flex-start"
                        buttonColor="secondary"
                        onClick={toggleLeftSideBar}
                        isToggleSidebarButton
                    />
                </SidebarEdge>
            </SidebarContainer>
        </>
    )
}

export default LeftSidebar
